import { render } from "./Cta-Startup.vue?vue&type=template&id=4d77425b"
import script from "./Cta-Startup.vue?vue&type=script&lang=js"
export * from "./Cta-Startup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__